import { render, staticRenderFns } from "./ContentPage.vue?vue&type=template&id=f78bede6&"
import script from "./ContentPage.vue?vue&type=script&lang=js&"
export * from "./ContentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f78bede6')) {
      api.createRecord('f78bede6', component.options)
    } else {
      api.reload('f78bede6', component.options)
    }
    module.hot.accept("./ContentPage.vue?vue&type=template&id=f78bede6&", function () {
      api.rerender('f78bede6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ContentPage.vue"
export default component.exports